<template>
	<div id="division">
		<div class="cent">
			<soso @addinfo="addinfo2"></soso>
		</div>
		<iteminfo :tableData="allinfo" @dele="dele"></iteminfo>
		
	</div>
</template>

<script>
	import addinfo from 'components/addinfo/addinfo'
	import soso from './soso'
	import iteminfo from './iteminfo'
	
	//网络相关
	import {getnavinfo} from 'network/home'
	import {getdele} from 'network/user'
	
	export default{
		name:'division2',
		data(){
			return{
				allinfo:[],
			}
		},
		methods:{
			addinfo2(msg) {
				this.allinfo = []
				getnavinfo(msg,"allinfo").then(res => {
					this.allinfo.push(...res.data.msg)
				})
			},
			dele(id,index){
				getdele(id).then(res =>{
					this.allinfo.splice(index,1)
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
				}).catch(res =>{
					this.$notify.error({
						title: '错误',
						message: '删除失败!',
					});
				})
			}
		},
		components:{
			soso,
			iteminfo
		}
	}
</script>

<style scoped>
	#division{
		float: right;
		/* border: solid 2px #ff557f; */
		width: calc(100vw - 410px);
	}
	.cent{
		width: 500px;
		margin-top: 30px;
		margin-left: 22%;
	}
</style>